import { useOptionalUser } from '@src/providers/UserProvider'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

/**
 * Route wrapper that redirects unauthenticated users to the login page.
 * Preserves the attempted URL so we can redirect back after login.
 */
const RequireAuth = () => {
  const user = useOptionalUser()
  const location = useLocation()

  if (!user) {
    // Redirect to login, preserving the attempted URL
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <Outlet />
}

export default RequireAuth
